export const EMAIL_FOLDERS = [
    { id: "inbox", label: "Inbox" },
    { id: "sent", label: "Sent" },
];

export const PHONE_FOLDERS = [
    { id: "all", label: "Phone Calls" },
];

export const PANEL_TYPE_MAP = {
    inbox: "conversations",
    sent: "conversations",
    all: "phone",
};
